import { memo } from 'react';
import { View } from 'react-native';

export const SkeletonBar = memo(
  ({
    width,
    height,
    color = '#e6e9ef',
  }: {
    width: number;
    height: number;
    color?: string;
  }) => (
    <View
      style={{
        width,
        height,
        backgroundColor: color,
        borderRadius: height / 2,
      }}
    />
  ),
);
